import React from 'react';
import { Link } from 'react-router-dom';
import UserMenu from './UserMenu';
import styles from './Header.module.css';

const Header: React.FC = () => {
  return (
    <header className={styles.header}>
      <nav className={styles.nav}>
        <div className={styles.logo}>
          <Link to="/">
            <img src="/logo.png" alt="dooocs logo" className={styles.logoImg} />
            <span>dooocs</span>
          </Link>
        </div>
        <ul className={styles.navList}>
          <li>
            <Link to="/" className={styles.navLink}>
              首页
            </Link>
          </li>
          <li>
            <Link to="https://www.dooocs.com/doc/" target="_blank" className={styles.navLink}>
              文档
            </Link>
          </li>
          <li>
            <UserMenu />
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header; 